fx.ns("models", class ThemeStickerTag extends fx.Model {

	constructor(data)
	{
		super(data);
	}

});